import React,{useState, useEffect} from "react";
import './App.css';
import {FormControl,Select,MenuItem} from "@material-ui/core";
import InfoBox from "./InfoBox";
import {Card, CardContent} from "@material-ui/core";
import Table from "./Table";
import {prettyPrintStat, prettyPrintTotal, sortData} from './Util'
import LineChart from "./LineChart";
import Map from './Map'
import 'leaflet/dist/leaflet.css'


function App() {

  const [countries, setCountries] = useState([])
    const [country, setCountry] = useState('Worldwide')
    const [countryInfo, setCountryInfo] = useState('Worldwide')
    const [table, setTable] = useState([])
    const [mapCenter, setMapCenter] = useState({ lat:34.80746, lng: -40.4796});
    const [mapZoom, setMapZoom] = useState(3)
    const [mapCountries, setMapCountries] = useState([])
    const [casesType, setCasesType] = useState('cases')


   useEffect(()=>{
        fetch('https://disease.sh/v3/covid-19/all')
           .then((response) => response.json())
           .then((data) =>{

               setCountryInfo(data);
           })
   },[]) ;

  useEffect(()=>{
      const getCountriesData = async () => {
          await fetch('https://disease.sh/v3/covid-19/countries')
              .then((response) => response.json())
              .then((data)=>{

                  const countries = data.map((country)=>(
                      {
                          name:country.country,
                          value:country.countryInfo.iso2,
                      }
                  ));

                  const sortedData = sortData(data);
                  setTable(sortedData);
                  setMapCountries(data);
                  setCountries(countries);
              });


      };
      getCountriesData()
  },[])



  const onCountryChange = async (event) => {
      const countryCode = event.target.value;
      setCountry(countryCode)

      const url = countryCode === 'Worldwide' ? 'https://disease.sh/v3/covid-19/all' : `https://disease.sh/v3/covid-19/countries/${countryCode}`
      await fetch(url)
          .then((response) => response.json())
          .then((data) =>{
              setCountry(countryCode);
              setCountryInfo(data);
              // console.log(data.countryInfo.lat,data.countryInfo.long)
              // let mapData =
              
              setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
              setMapZoom(4);
              });

          }



    console.log(casesType)

  return (
    <div className="App">
        <div className='left'>
            <div className='head'>
                <h1 className='tracker'> COVID-19 TRACKER</h1>
                <FormControl className="app__dropdown">
                    <Select variant='outlined' onChange={onCountryChange} value={country}>
                        <MenuItem value='Worldwide'>Worldwide</MenuItem>
                        {countries.map((country)=>(
                            <MenuItem value={country.value}>{country.name}</MenuItem>  ))}

                    </Select>
                </FormControl>
            </div>
            <div className='cardBox'>
                <InfoBox isRed active={casesType=== 'cases'} onClick={()=> setCasesType('cases')} title='Coronavirus Cases' cases={prettyPrintStat(countryInfo.todayCases)} total={prettyPrintTotal(countryInfo.cases)}/>

                <InfoBox active={casesType=== 'recovered'} onClick={()=> setCasesType('recovered')} title='Recovered' cases={prettyPrintStat(countryInfo.todayRecovered)} total={prettyPrintTotal(countryInfo.recovered)}/>

                <InfoBox isRed active={casesType=== 'deaths'} onClick={()=> setCasesType('deaths')} title='Deaths' cases={prettyPrintStat(countryInfo.todayDeaths)} total={prettyPrintTotal(countryInfo.deaths)}/>
            </div>

            <Map countries={mapCountries} casesType={casesType} center={mapCenter} zoom={mapZoom}/>

        </div>
        <div className='right'>
            <Card>
                <CardContent>
                    <h3>Corona cases by Country</h3>
                    <Table countries={table}/>
                    <h3>Worldwide new {casesType}</h3>
                    <LineChart className="app__graph" casesType={casesType} />
                </CardContent>
            </Card>

        </div>
    </div>
  );
}

export default App;
